module.exports = __webpack_public_path__ + "img/hs_ev2.992b1494.png";